import {Card, Col, Row, Tabs, Skeleton} from 'antd';
import {useEffect, useState} from 'react';
import {useBreadcrumbContext} from '../../../../domain/utility/AppContextProvider/BreadcrumbContextProvider';
import IntlMessages from '../../../../domain/utility/IntlMessages';
import OrderDetailsHeader from './order-details-header';
import type {TabsProps} from 'antd';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import {ordersService} from '../../../../shared/services/orders';
import {OrderDetailsDto} from '../../../../shared/services/orders/dto/order-details-dto';
import OrderDetailsInfo from './order-details-info';
import OrderDetailsItems from './order-details-items';
import MainUtils from 'src/shared/utils/main';
import TrackShipmentModal from './track-shipment-modal';

interface IOrderDetailsProps {}

const OrderDetails = (props: IOrderDetailsProps) => {
  const {setBreadcrumb}: any = useBreadcrumbContext();

  const {messages} = useIntl();

  const {id} = useParams();

  const [orderDetails, setOrderDetails] = useState<OrderDetailsDto>();

  const [isOrderDetailsLodaing, setIsOrderDetailsLodaing] =
    useState<boolean>(false);

  const [openTrackShipmentModal, setOpenTrackShipmentModal] = useState(false);

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='orders.sideBarName' />,
        url: '/orders/orders-list',
      },
      {
        text: <IntlMessages id='orders.sideBarName.details' />,
        url: `/orders/orders-list/order-details/${id}`,
      },
    ]);
  }, [id]);

  useEffect(() => {
    if (!MainUtils.isEmptyValue(id)) {
      (async () => {
        try {
          setIsOrderDetailsLodaing(true);
          let orderDetailsData = await ordersService.getOrderDetails(id ?? '');
          setOrderDetails(orderDetailsData);
        } catch (error) {
          console.error(error);
        } finally {
          setIsOrderDetailsLodaing(false);
        }
      })();
    }
  }, [id]);

  const itemsTab: TabsProps['items'] = [
    {
      key: 'orderInfo',
      label: `${messages['orders.orderDetails.orderInfo'].toString()}`,
      children: <OrderDetailsInfo orderDetails={orderDetails} />,
    },
    {
      key: 'orderItems',
      label: `${messages['orders.orderDetails.orderItems'].toString()}`,
      children: <OrderDetailsItems orderDetails={orderDetails} />,
    },
  ];

  const onOpenTrackShipmentModal = () => {
    setOpenTrackShipmentModal(true);
  };

  return (
    <Card>
      <Skeleton active loading={isOrderDetailsLodaing}>
        <Row gutter={[0, 48]}>
          <Col span={24}>
            <OrderDetailsHeader
              orderDetails={orderDetails}
              onOpenTrackShipmentModal={onOpenTrackShipmentModal}
            />
          </Col>

          <Col span={24}>
            <Tabs defaultActiveKey='orderInfo' items={itemsTab} />
          </Col>
        </Row>
      </Skeleton>
      <TrackShipmentModal
        visible={openTrackShipmentModal}
        orderDetails={orderDetails}
        onCancel={() => setOpenTrackShipmentModal(false)}
      />
    </Card>
  );
};

export default OrderDetails;
